import { Component } from '@angular/core';

//import { AboutPage } from '../about/about';
import { ContactPage } from '../contact/contact';
//import { HomePage } from '../home/home';
import { DistilleriesPage } from '../distilleries/distilleries';
import { RatingsPage } from '../ratings/ratings';
import { ShelvesPage } from '../shelves/shelves';
import { BasketPage } from '../basket/basket';
import { ListPage } from '../list/list';
import { BottlersPage } from '../bottlers/bottlers';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = ListPage;
  tab2Root = DistilleriesPage;
  tab3Root = ShelvesPage;
  tab4Root = RatingsPage;
  tab5Root = BottlersPage;
  tab6Root = BasketPage;
  tab7Root = ContactPage;
  
  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts